import React from 'react';
import { Entity } from '@sketchpixy/rubix/lib/L20n';

import Alert from '../Alert.jsx';

export default class ManagerPasswordResetModal extends React.Component {
  hideModal() {
    const { hideModal } = this.props;
    hideModal();
  }

  render() {
    return (
      <Alert
        type="success"
        visible
        onOutsideClick={() => this.hideModal()}
        title={<Entity entity="modalTitle" data={{ modal: 'userPasswordReset' }} />}
        message={<Entity entity="modalMessage" data={{ modal: 'managerRecoverPassword' }} />}
        onConfirm={() => this.hideModal()}
      />
    );
  }
}
